module.exports = __webpack_public_path__ + "f07a34b8d0a9f8910177fd6a0f631964.svg";